module.exports = __webpack_public_path__ + "img/active.6cb86a9d.svg";